import React from 'react'
import { Button } from 'antd'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { DownloadOutlined } from '@ant-design/icons'
import { IntegrationPurchase } from 'src/core/models'
import styles from './IntegrationPurchaseDownloadButton.module.scss'
import { integrationPurchasesSelector, selectCurrencyToken } from 'src/features'
import {
  downloadCsv,
  getCsvFromObjectArray,
  getActualDateFormated,
  getIntegrationPurchaseBuyerData,
} from 'src/core/helpers'

const IntegrationPurchaseDownloadButton: React.FC = () => {
  const { t } = useTranslation()
  const currency_code = useAppSelector(selectCurrencyToken)
  const { data: purchaseList } = useAppSelector(integrationPurchasesSelector)

  const handleCsvDownload = () => {
    const results = purchaseList.map((item: IntegrationPurchase) => {
      return {
        project_name: item.name?.replaceAll(',', ';'),
        client_name: getIntegrationPurchaseBuyerData(item)?.replaceAll(',', ';'),
        client_email: item.buyer_data.email?.replaceAll(',', ';'),
        transaction_value: item.amount,
        currency: currency_code,
        compendated_co2: item.co2_amount,
        created_date: item.created?.replaceAll(',', ';')
      }
    })
    const csv = getCsvFromObjectArray(results)
    const csvFileName = `${getActualDateFormated()}_integration_purchases`
    downloadCsv(csv, csvFileName)
  }

  return <Button
    block
    className={styles.button}
    icon={<DownloadOutlined />}
    disabled={!purchaseList.length}
    onClick={handleCsvDownload}
  >
    {t('general.DownLoadCSV')}
  </Button>
}

export default IntegrationPurchaseDownloadButton
